import { Box, Step, StepLabel, Stepper } from '@mui/material';
import { useEffect, useState, } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { setBackHandler, setHeaderTitle } from '../../helpers/header.helper';
import * as selector from "../../selectors/selectors";
import { UserService } from '../../services/UserService';
import SelectAddon from '../add-phone-number/select-addon.component';
import SelectPlan from '../add-phone-number/select-plan.component';
import ManualPayment from "../payment/manualPayment.component";
import PaymentStatus from '../payment/payment-status.component';
import Payment from '../payment/payment.component';
import { AppRoutes } from '../routes/route.path';

const Recharge = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;

    const queryParams = new URLSearchParams(location.search);
    const isFreshNavigation = queryParams.get("reset") === "true";

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const [activeStep, setActiveStep] = useState(0);
    const [stepdata, setStepdata] = useState<any>()
    const IsManualPayment = false // state.ManualPayment

    const setBack = (index, label) => {
        if (index < activeStep) {
            label === "Payment" ? setActiveStep(0) : setActiveStep(index)
        }

    }


    const handleNext = (data?: any) => {
        setStepdata({ ...stepdata, ...data })
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

    const getRechargeSteps = (IsMobileDevice: boolean, IsTeamsApp: boolean, IsAddonRecharge: boolean, IsManualPayment?: boolean) => IsAddonRecharge ? [
        {
            label: "Select Add-on",
            component: <SelectAddon HandleNext={handleNext} Stepdata={stepdata} />
        },
        {
            label: "Payment",
            component: IsManualPayment ? <ManualPayment HandleNext={handleNext} Stepdata={stepdata} /> : <Payment IsTeamsApp={IsTeamsApp} HandleNext={handleNext} IsMobileDevice={IsMobileDevice} Stepdata={stepdata} />
        },
        {
            label: "Payment Status",
            component: <PaymentStatus IsTeamsApp={IsTeamsApp} Stepdata={stepdata} />
        },
    ] : [
        {
            label: "Select Plan",
            component: <SelectPlan onSelectPlan={handleNext} />
        },
        {
            label: "Select Add-on",
            component: <SelectAddon HandleNext={handleNext} Stepdata={stepdata} />
        },
        {
            label: "Payment",
            component: IsManualPayment ? <ManualPayment HandleNext={handleNext} Stepdata={stepdata} /> : <Payment IsTeamsApp={IsTeamsApp} HandleNext={handleNext} IsMobileDevice={IsMobileDevice} Stepdata={stepdata} />
        },
        {
            label: "Payment Status",
            component: <PaymentStatus IsTeamsApp={IsTeamsApp} Stepdata={stepdata} />
        },
    ];

    useEffect(() => {
        if (isFreshNavigation) {            
            setActiveStep(0); // Only reset if ?fresh=true
        }
        setHeaderTitle("Recharge")

        setBackHandler(() => navigate(UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : AppRoutes.PLANS))
    }, [location.key])

    const steps = getRechargeSteps(IsMobileDevice, IsTeamsApp, state.IsAddonRecharge, IsManualPayment);
    const Steps = UserService.hasSysAdminRole() ? steps.slice(0, steps.length - 1) : IsManualPayment ? steps.slice(0, steps.length - 1) : steps
    return (
        <>
            <Box className='d-flex flex-direction align-center '>
                <Stepper activeStep={activeStep} alternativeLabel className={'w-80 mb-1 c-pointer'} >
                    {Steps.map((step, index) => (
                        <Step key={index} onClick={() => setBack(index, step.label)}>
                            <StepLabel className={'h3-regular'}>{step.label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <div className='d-flex '>
                {steps[activeStep].component}
            </div>
        </>
    )
}
export default Recharge;